import { Link } from 'react-router';
import type { WayRoundPath } from './homeWords.ts';

/** One place on the way round: its words, and how many wait there, if any. */
export interface WayRoundItem {
  path: WayRoundPath;
  label: string;
  count?: string | number | null;
}

const PLACE = 'inline-flex min-h-11 items-baseline gap-1.5 py-2.5 text-[1.0625rem] text-ink underline decoration-rule-strong underline-offset-[0.3em]';

/**
 * The way round a client's project, just under the price on their home (Jason, 2026-10-03): always all of it, so nothing
 * is hidden until it fills. Each place a link (`to`); drawn alone, as the Introduction draws it, each its words only.
 */
export function WayRound({ items, to, className = '' }: { items: readonly WayRoundItem[]; to?: (path: WayRoundPath) => string; className?: string }) {
  return (
    <nav aria-label="Your project" className={`border-y border-rule ${className}`}>
      <ul className="flex flex-wrap gap-x-7">
        {items.map(({ path, label, count }) => {
          const words = (
            <>
              {label}
              {count !== null && count !== undefined ? <span className="num text-[0.8125rem] text-ink-3 no-underline">{count}</span> : null}
            </>
          );
          return (
            <li key={path}>
              {to ? (
                <Link to={to(path)} className={`${PLACE} hover:decoration-ink`}>
                  {words}
                </Link>
              ) : (
                <span className={PLACE}>{words}</span>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
